// import { isObjectEmpty } from "../commonUtils";
// import { getEligibleEmployees } from "./bidGroupUtils";

export const validateAllotments = (bidGroup, totalAllotments, calcDailyAllotments, schedMonth, schedYear) => {
  //   const totalEligibleEmployees = getEligibleEmployees(bidGroup)?.length;
  //   if (
  //     schedMonth !== "" &&
  //     schedYear !== "" &&
  //     bidGroup?.length > 0 &&
  //     (totalAllotments === 0 ||
  //       isObjectEmpty(calcDailyAllotments) ||
  //       (totalEligibleEmployees === 0 && calcDailyAllotments.amOrPmCount !== 1) ||
  //       (totalAllotments > 0 &&
  //         totalEligibleEmployees > 0 &&
  //         Math.ceil(totalEligibleEmployees / 30) !== calcDailyAllotments.amOrPmCount))
  //     //Ex: Initially we have 30 employees, calcDailyAllotments as 1. Then added one employee, we should get calcDailyAllotments as 2 and vice versa.
  //   ) {
  //     return "Incorrect number of allotments";
  //   }
  return "";
};
